import classNames from "classnames";
import React, { LabelHTMLAttributes } from "react";

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
    children?: React.ReactNode;
    className?: string;
    check?: boolean;
    for?: string;
    hidden?: boolean;
};

const Label = ({
    children,
    className,
    check,
    for: htmlFor,
    hidden,
}: LabelProps) => {
    const classes = classNames(
        className,
        hidden ? "sr-only" : false,
        check ? "form-check-label" : false,
    );

    return (
        <label className={classes} htmlFor={htmlFor}>
            {children}
        </label>
    );
};

export { Label };
